import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = (props) => {
  let { data } = props;
  const [labels, setlabels] = useState([]);
  const [series, setSeries] = useState([]);

  useEffect(() => {
    if (props.data) {
      let { series, labels } = data;

      setlabels(labels);
      setSeries(series);
    }
  }, [props]);

  return (
    <div style={{ width: 400, height: 200, marginTop: 10 }}>
      {labels.length > 0 ? (
        <Pie
          data={{
            labels: labels,
            datasets: [
              {
                data: series,
                backgroundColor: [
                  "#FFB200",
                  "#FF3A29",
                  "#34B53A",
                  "#1A55AF",
                  "#FFD700B5",
                ],
                borderColor: [
                  "rgba(255, 99, 132, 1)",
                  "rgba(54, 162, 235, 1)",
                  "rgba(255, 206, 86, 1)",
                  "rgba(75, 192, 192, 1)",
                  "rgba(153, 102, 255, 1)",
                ],
                borderWidth: 1,
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: "right",
                labels: {
                  usePointStyle: true,
                  pointStyle: "circle",
                  padding: 20,
                },
              },
            },
          }}
        />
      ) : (
        <div className="text-gray-600 text-center">
          <p>No Data Found</p>
        </div>
      )}
    </div>
  );
};

export default PieChart;
